import { render } from "./CurrentlyReadingBookListCard.vue?vue&type=template&id=ee00d2e4&scoped=true"
import script from "./CurrentlyReadingBookListCard.vue?vue&type=script&lang=js"
export * from "./CurrentlyReadingBookListCard.vue?vue&type=script&lang=js"

import "./CurrentlyReadingBookListCard.vue?vue&type=style&index=0&id=ee00d2e4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ee00d2e4"]])

export default __exports__